// CSV outputs are persisted by downstream table tools, including quoted multiline cells.
export function parseCsv(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [], cell = '', quoted = false;
  const source = text.replace(/^\uFEFF/, '');
  for (let i = 0; i < source.length; i++) {
    const char = source[i];
    if (char === '"') {
      if (quoted && source[i + 1] === '"') { cell += '"'; i++; }
      else quoted = !quoted;
    } else if (char === ',' && !quoted) { row.push(cell); cell = ''; }
    else if ((char === '\n' || char === '\r') && !quoted) {
      if (char === '\r' && source[i + 1] === '\n') i++;
      row.push(cell); rows.push(row); row = []; cell = '';
    } else cell += char;
  }
  if (cell || row.length) { row.push(cell); rows.push(row); }
  return rows;
}
export function csvDocument(text: string) {
  const [columns = [], ...values] = parseCsv(text);
  return { content: { type: 'table', columns, rows: values.map(row => Object.fromEntries(columns.map((key, index) => {
    const value = row[index] ?? '';
    return [key, /^-?(0|[1-9]\d*)(\.\d+)?$/.test(value) ? Number(value) : value];
  }))) } };
}
